import Vue from 'vue'
import Vuex from 'vuex';
import {BROWSER} from "@/enum/lib"
import list from "moment-timezone/data/meta/latest.json";
import moment from 'moment-timezone';

const isAuth = () => {
    try {
        return !!localStorage.getItem('accessToken')
    } catch (e) {
        return false;
    }
}

// 타임존 리스트
const countriesList = JSON.parse(JSON.stringify(list.countries));
// 사용자 타임존
const city = moment.tz.guess();
// 체크 시간대
const checkList = [
    'KR',
];

const checkTime = (productCheck = false) => {
    // 체크 시단대의 코드값으로 타임존 리스트에서 국가 코드 매칭
    let checkCity = [];
    let tempCheckList = JSON.parse(JSON.stringify(checkList))

    if (productCheck) {
        /*
        API 서버 체크 하여 운영일경우 checkTime 에서 제외
         */
        tempCheckList = (
            process.env.VUE_APP_API_DOMAIN === 'https://prod.api.rebless.pro' ||
            process.env.VUE_APP_API_DOMAIN === 'https://stage2.api.rebless.pro'
        ) ? tempCheckList : []
    }

    tempCheckList.map((value) => {
        countriesList[value]?.zones.map((cityValue) => {
            checkCity.push(cityValue);
        })
    })

    return checkCity.includes(city);
}

Vue.use(Vuex);
/**
 * @typedef {Object} ResPatientDefaultDto
 * @property {PatientInfoDto} patientInfo
 * @property {PatientStatusDto} patientStatus
 * @property {number} recentArom
 * @property {number} recentProm
 */
/**
 * @typedef {Object} PatientInfoDto
 * @property {number} patientInfoBrainLesion
 * @property {number} patientInfoHeight
 * @property {number} patientInfoWeight
 * @property {number} seqMedicalRelation
 * @property {number} seqPatientInfo
 * @property {string} patientInfoImageUrl
 * @property {string} patientInfoOccurrenceDate
 * @property {string} patientInfoPrimaryDiagnosis
 * @property {string} patientInfoSecondaryDiagnosis
 * @property {string} modifyDatetime
 * */
/**
 * @typedef {Object} PatientStatusDto
 * @property {number} seqMedicalRelation
 * @property {number} seqPatientStatus
 * @property {number} patientStatusInfection
 * @property {number} patientStatusMMT
 * @property {number} patientStatusMRS
 * @property {string} patientStatusMedication
 * @property {string} patientStatusParalysisPart
 * @property {string} patientStatusParalysisPosition
 * @property {string} createDatetime
 * */
export default new Vuex.Store({
    state: {
        rootKey: new Date().valueOf(),
        deviceBrowser: {
            userAgent: navigator.userAgent.toLowerCase(),
            notNewWindow: false,
            speakerNonCheck: false,
            touchDevice: false,
            browser: BROWSER.DEFAULT,
        },
        mainMenu: 0,
        navMenu: 0,
        landingMenu: 0,
        isHamburgerVisible: false,
        auth: {
            seqUser: '',
            seqManager: '',
            userId: '',
            userName: '',
            accessToken: '',
            //refreshToken : '',
            isAuth: isAuth(),
        },
        browserSize: {
            width: window.innerWidth,
            height: window.innerHeight,
        },
        unit: '',
        seqPatient: '',
        patientList: [],
        scheduleList: [],
        refreshSchedule: false,
        refreshPatientSchedule: false,
        report: {
            romChartData: {
                chartData: {},
                requestData: {},
            },
            expertOpinionData: '',
            chiefComplainData: '',
            romChartImage: {
                src: '',
                width: 0,
                height: 0
            }
        },
        videoCall: {
            open: false,
            selectedSchedule: '',
            status: 'waiting',
        },
        isUnreadNotifications: true, // true 인 경우 다 읽음/ false 인 경우 다 안읽음
        newNotification: '',
        imageSlider: {
            open: false,
            sliderId: 0,
            src: [],
            index: 0,
            sliderTitle: '',
        },
        latestPurchaseInfo: {
            // TODO: 운영 반영시 제거
            isSubscribeActive: false,
            paymentInfo: {
                defaultProductSubTitle: '',
                defaultProductTitle: '',
                paymentType: -1,
                seqProduct: -1,
                productPatientProfileLimit: process.env.VUE_APP_MODE === 'LIVE' ? 1000 : 30,
            }
        },
    },
    getters: {
        getRootKeyAsync: async (state) => {
            return state.rootKey;
        },
        getDeviceBrowser: state => {
            return state.deviceBrowser;
        },
        getMainMenu: state => {
            return state.mainMenu;
        },
        getNavMenu: state => {
            return state.navMenu;
        },
        getLandingMenu: state => {
            return state.landingMenu;
        },
        getCurrentMainMenu: state => {
            return state.mainMenu;
        },
        getAuth: state => {
            return {
                ...state.auth,
            };
        },
        getBrowserSize: (state) => {
            return state.browserSize;
        },
        getAccessToken: state => {
            return state.auth.accessToken;
        },
        getSeqPatient: state => {
            return state.seqPatient;
        },
        getPatientList: state => {
            return state.patientList;
        },
        getScheduleList: state => {
            return state.scheduleList;
        },
        getPatientBySeqPatientFromPatientList: state => seqPatient => {
            return state.patientList.find(item => item.seqPatient === seqPatient)
        },
        getIsHamburgerVisible: state => {
            return state.isHamburgerVisible;
        },
        getReport: (state) => {
            return state.report;
        },
        getReportRomChartData: (state) => {
            return state.report.romChartData;
        },
        getVideoCallOpen: (state) => {
            return state.videoCall.open;
        },
        getVideoCallSelectedSchedule: (state) => {
            return state.videoCall.selectedSchedule;
        },
        getVideoCallStatus: (state) => {
            return state.videoCall.status;
        },
        getRefreshSchedule: (state) => {
            return state.refreshSchedule
        },
        getRefreshPatientSchedule: (state) => {
            return state.refreshPatientSchedule
        },
        getIsUnreadNotifications: (state) => {
            return state.isUnreadNotifications;
        },
        getImageSlider: (state) => {
            return state.imageSlider;
        },
        getLatestPurchaseInfo: (state) => {
            return state.latestPurchaseInfo;
        },
        getCheckTimeZone: () => {
            return checkTime();
        },
        getCheckTimeZoneProduct: () => {
            return checkTime(true);
        },
    },
    mutations: {
        regenRootKeyToVuex(state) {
            state.rootKey = new Date().valueOf();
        },
        setDeviceBrowser(state, payload) {
            state.deviceBrowser = payload;
        },
        setMainMenu(state, payload) {
            state.mainMenu = payload.mainMenu;
        },
        setNavMenu(state, payload) {
            state.navMenu = payload.navMenu;
        },
        setSeqPatient(state, payload) {
            state.seqPatient = payload.seqPatient;
        },
        setUnit(state, payload) {
            state.unit = payload;
        },
        setLandingMenu(state, payload) {
            state.landingMenu = payload.landingMenu;
        },
        setBrowserSize(state, payload) {
            state.browserSize = payload;
        },
        setAuth(state, payload) {
            state.auth.accessToken = payload.accessToken;
            state.auth.seqUser = payload.seqUser;
            state.auth.seqManager = payload.seqManager;
            state.auth.userId = payload.userId;
            state.auth.userName = payload.userName;
            state.auth.isAuth = payload.isAuth;
        },
        setIsAuth(state, payload) {
            state.auth.isAuth = payload.isAuth;
        },
        setUserName(state, payload) {
            state.auth.userName = payload.userName;
        },
        setUserId(state, payload) {
            state.auth.userId = payload.userId;
        },
        setSeqUser(state, payload) {
            state.auth.seqUser = payload.seqUser;
        },
        setSeqManager(state, payload) {
            state.auth.seqManager = payload.seqManager;
        },
        setTokens(state, payload) {
            state.auth.accessToken = payload.accessToken;
        },
        setAccessTokens(state, payload) {
            state.auth.accessToken = payload.accessToken;
        },
        initPatientList(state, payload) {
            Vue.set(state, 'patientList', [...payload.patientList]);
        },
        initScheduleList(state, payload) {
            Vue.set(state, 'scheduleList', [...payload.scheduleList]);
        },
        initPatientListAndScheduleList(state, payload) {
            Vue.set(state, 'patientList', [...payload.patientList]);
            Vue.set(state, 'scheduleList', [...payload.scheduleList]);
        },
        setIsHamburgerVisible(state, payload) {
            state.isHamburgerVisible = payload.isHamburgerVisible;
        },
        toggleIsHamburgerVisible(state) {
            state.isHamburgerVisible = !state.isHamburgerVisible;
        },
        emptyPatientList(state) {
            while (state.patientList.length !== 0) {
                state.patientList.pop();
            }
        },
        setRomChartDataToVuex(state, payload) {
            state.report.romChartData = payload.chartData
            state.report.romChartImage = payload?.romChartImage ?? ''
        },
        setExpertOpinionDataToVuex(state, payload) {
            state.report.expertOpinionData = payload.expertOpinionData
        },
        setChiefComplainDataToVuex(state, payload) {
            state.report.chiefComplainData = payload.chiefComplainData;
        },
        setRomChartImageDataToVuex(state, payload) {
            state.report.romChartImage = payload.romChartImage;
        },
        resetReportToVuex(state) {
            state.report = {
                romChartData: {
                    chartData: {},
                    requestData: {},
                },
                expertOpinionData: '',
                chiefComplainData: '',
                romChartImage: {
                    src: '',
                    width: 0,
                    height: 0
                }
            }
        },
        setPatientStatus(state, payload) {
            for (let i = 0; state.patientList.length > i; i++) {
                if (state.patientList[i].patientInfo.seqMedicalRelation === payload.seqMedicalRelation) {
                    state.patientList[i].patientStatus = payload.patientStatus;
                }
            }
        },
        toggleRemoteModalToVuex(state, payload) {
            if (payload.open !== undefined)
                state.videoCall.open = payload.open;

            if (payload.selectedSchedule !== undefined)
                state.videoCall.selectedSchedule = payload.selectedSchedule;

            if (payload.status !== undefined)
                state.videoCall.status = payload.status;
        },
        refreshScheduleForToday(state, payload) {
            state.refreshSchedule = payload;
        },
        refreshScheduleForPatient(state, payload) {
            state.refreshPatientSchedule = payload;
        },
        changeNotificationsReadStatus(state, payload) {
            state.isUnreadNotifications = payload;
        },
        newNotificationHasArrived(state, payload) {
            state.newNotification = payload;
        },
        setImageSlider(state, payload) {
            state.imageSlider = payload;
        },
        setLatestPurchaseInfo(state, payload) {
            state.latestPurchaseInfo = payload;
        },
    },
    actions: {
        modifyPatientInfo(store, newPatientInfo) {
            store.dispatch('getSelectedPatient').then((data) => {
                if (newPatientInfo?.patientInfo) {
                    data.patientInfo = JSON.parse(JSON.stringify(newPatientInfo.patientInfo));
                }
                if (newPatientInfo?.patientStatus) {
                    data.patientStatus = JSON.parse(JSON.stringify(newPatientInfo.patientStatus));
                }
            });
        },
        changeDeviceBrowser(store) {
            const userAgent = navigator.userAgent.toLowerCase();
            const touchDevice = navigator.maxTouchPoints !== 0;
            const mobile = /iPhone|iPad|iPod|Android/i;
            const isMobile = mobile.test(userAgent);
            const isIpad = userAgent.match(/ipad/i) !== null

            const edge = userAgent.includes('edg');
            const safari = (userAgent.includes('safari') && !userAgent.includes('chrome'));
            const firefox = userAgent.includes('firefox');
            const samsungBrowser = userAgent.includes('samsungbrowser');
            const chrome = (userAgent.includes('chrome') && !edge && !samsungBrowser);

            const deviceBrowser = {
                userAgent: userAgent,
                touchDevice: touchDevice,
                notNewWindow: isMobile || firefox || touchDevice,
                speakerNonCheck: isIpad || isMobile || firefox || safari,
                browser: ((chrome && 1) + (edge && 2) + (safari && 3) + (firefox && 4) + (samsungBrowser && 5))
                    || BROWSER.DEFAULT,
            };

            store.commit('setDeviceBrowser', deviceBrowser);
        },
        changeNavMenu(store, navMenu) {
            store.commit('setNavMenu', {navMenu});
        },
        changeMainMenu(store, mainMenu) {
            store.commit('setMainMenu', {mainMenu});
        },
        changeUnitToVueX(store, unit) {
            store.commit('setUnit', unit);
        },
        inspectSelectPatient(store, seqPatient) {
            store.commit('setSeqPatient', {seqPatient});
        },
        changeLandingMenu(store, landingMenu) {
            store.commit('setLandingMenu', {landingMenu})
        },
        changeAuth(store, auth) {
            const payload = {
                seqUser: auth.seqUser,
                seqManager: auth.seqManager,
                userId: auth.userId,
                userName: auth.userName,
                accessToken: auth.accessToken,
                //refreshToken : auth.refreshToken,
                isAuth: auth.isAuth,
            };
            store.commit('setAuth', payload);
        },
        initPatientList(store, payload) {
            return new Promise(resolve => {
                store.commit('initPatientList', {patientList: payload.patientList});
                resolve();
            })
        },
        initScheduleList(store, payload) {
            return new Promise(resolve => {
                store.commit('initScheduleList', {scheduleList: payload.scheduleList});
                resolve();
            })
        },
        initPatientListAndScheduleList(store, payload) {
            return new Promise(resolve => {
                store.commit('initPatientListAndScheduleList', {
                    patientList: payload.patientList,
                    scheduleList: payload.scheduleList
                });
                resolve();
            })
        },
        getAllPatientFromPatientList(store) {
            return new Promise(resolve => {
                const data = store.getters.getPatientList;
                resolve(data);
            })
        },
        getPatientBySeqPatientFromPatientListNoPromise(store, seqPatient) {
            return store.getters.getPatientBySeqPatientFromPatientList(seqPatient)
        },
        getPatientBySeqPatientFromPatientList(store, seqPatient) {
            return new Promise((resolve) => {
                const data = store.getters.getPatientBySeqPatientFromPatientList(seqPatient);
                resolve(data);
            });
        },
        logOut(store) {
            store.commit('setNavMenu', {navMenu: 0});
            store.commit('emptyPatientList');
            return store.commit('setIsAuth', {isAuth: false});
        },
        setHamburgerVisible(store, isHamburgerVisible) {
            store.commit('setIsHamburgerVisible', {isHamburgerVisible})
        },
        appendPatientIntoPatientList(store, patientInfo) {
            return new Promise(resolve => {
                const patientList = store.getters.getPatientList;
                patientList.push(patientInfo);
                store.commit(`initPatientList`, {patientList: patientList});
                resolve();
            });
        },
        deletePatientFromPatientList(store, patientData) {
            return new Promise((resolve) => {
                const patientList = store.getters.getPatientList;
                for (let value of patientData) {
                    const dataIdx = patientList.findIndex(it => it.seqPatient === value);
                    patientList.removeIdxIfExist(dataIdx);
                }

                store.commit(`initPatientList`, {patientList: patientList});
                resolve();
            });

        },
        getSelectedPatient(store) {
            return new Promise((resolve, reject) => {
                const seqPatient = store.getters.getSeqPatient;
                if (seqPatient) {
                    const data = store.getters.getPatientBySeqPatientFromPatientList(seqPatient);
                    resolve(data);
                } else {
                    reject(`[vuex][getSelectedPatient]no patient selected`)
                }
            });
        },
        addRomChartDataToVuex(store, chartData) {
            store.commit('setRomChartDataToVuex', {chartData})
        },
        resetRomChartDataToVuex(store) {
            const chartData = {
                chartData: {},
                requestData: {}
            }
            store.commit('setRomChartDataToVuex', {chartData})
        },
        updateExpertOpinionData(store, expertOpinionData) {
            store.commit('setExpertOpinionDataToVuex', {expertOpinionData})
        },
        updateChiefComplainData(store, chiefComplainData) {
            store.commit('setChiefComplainDataToVuex', {chiefComplainData});
        },
        updateRomChartImageData(store, romChartImage) {
            store.commit(`setRomChartImageDataToVuex`, {romChartImage})
        },
        resetReport(store) {
            store.commit('resetReportToVuex');
        },
        regenRootKey(store) {
            store.commit('regenRootKeyToVuex')
        },
        toggleRemoteModal(store, {open, selectedSchedule, status}) {
            store.commit('toggleRemoteModalToVuex', {open, selectedSchedule, status});
        },
        refreshScheduleForToday(store, boolean) {
            store.commit('refreshScheduleForToday', boolean);
        },
        refreshScheduleForPatient(store, boolean) {
            store.commit('refreshScheduleForPatient', boolean);
        },
        changeNotificationsReadStatus(store, boolean) {
            store.commit('changeNotificationsReadStatus', boolean);
        },
        newNotificationHasArrived(store, notification) {
            store.commit('newNotificationHasArrived', notification);
        },
        changeBrowserSize(store, {width, height}) {
            store.commit('setBrowserSize', {width, height});
        },
        changeLatestPurchaseInfo(store, data) {
            store.commit('setLatestPurchaseInfo', data);
        },
    }
})